import { EquipmentLogbookDetailPrintModel } from "./equipment-loogbook-detail-print.model";
import { EquipmentLogbookTotalPrintModel } from "./equipment-loogbook-total-print.model";

export class EquipmentLogbookPrintModel {
  equipmentLogbookId: number = 0;
  enterpriseLogo: string | null = null;
  enterpriseName: string = "";
  branchName: string = "";
  consecutive: number = 0;
  equipmentName: string = "";
  equipmentCode: number = 0;
  trademark: string = "";
  reference: string = "";
  serie: string = "";
  commercialName: string = "";
  equipmentType: string = "";
  provider: string = "";
  purchaseValue: number = 0;
  capacity: string = "";
  invoiceNumber: number | null = null;
  purchaseDate: Date = new Date();
  warrantyInitialDate: Date | null = null;
  warrantyFinalDate: Date | null = null;
  yearManufacture: number | null = null;
  engineType: string = "";
  engineCode: string = "";
  referenceEngine: string = "";
  trademarkEngine: string = "";
  serieEngine: string = "";
  voltage: string = "";
  power: string = "";
  amperage: string = "";
  userAuthenticated: string = "";
  equipmentLogbookDetails: EquipmentLogbookDetailPrintModel[] = [];
  equipmentLogbookTotals: EquipmentLogbookTotalPrintModel[] = [];
}